import { type MutationHookOptions, useMutation } from "@apollo/client";
import { ConnectPaynetMutation } from "../graphql/mutations";
import type {
  ConnectPaynetMutationType,
  ConnectPaynetMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useConnectPaynetMutation = (
  options?: MutationHookOptions<
    ConnectPaynetMutationType,
    ConnectPaynetMutationVariablesType
  >
) => {
  return useMutation<
    ConnectPaynetMutationType,
    ConnectPaynetMutationVariablesType
  >(ConnectPaynetMutation, options);
};
